
import barba from '@barba/core';
import Swiper from 'swiper';
import KeenSlider from 'keen-slider'

export default class{

	constructor(){

        barba.hooks.afterOnce((data) => {
            // this.heroSlider()
            // this.blogSlider()
            this.verticalSlider01()
            this.verticalSlider02()
            this.featureSlider01()
            this.featureSlider02()
            this.productSlider()
            this.serviceSlider()
            // this.pickupSlider()
            // this.eventSlider()

        })
        barba.hooks.after((data) => {
            // this.heroSlider()
            // this.blogSlider()
            this.verticalSlider01()
            this.verticalSlider02()
            this.featureSlider01()
            this.featureSlider02()
            this.productSlider()
            this.serviceSlider()
            // this.pickupSlider()
            // this.eventSlider()
        });
        
    }
    
    heroSlider(){
        
        new Swiper ('#hero--slider',{
            loop: true,
            effect :'fade',
            speed:3000,
            allowTouchMove :false,
            simulateTouch:false,
            autoplay: {
                delay: 4000
            }
        })
    }
    
    blogSlider(){
        // const blog_thumbnails = document.querySelectorAll('.blog-slider-thumbnails a');
        const blogSlider = new Swiper('.js-blog__slider', {
            loop: true,
            speed:400,
            easing:"linear",
            loopAdditionalSlides : 5,
            slidesPerView: 'auto',
            spaceBetween: 20,
            simulateTouch:true,
            centeredSlides: false,
            breakpoints: {
                
                576: {
                    slidesPerView: 'auto',
                    spaceBetween:  40,
                }
            }
        });
        
        // const blogThumbnailAddEvent = (el,i) => {
        //     el.addEventListener('click',function(e){
        //         e.preventDefault();
        //         blogSlider.slideTo(i+1);
        //     })
        // }

        // for(var i = 0; i <  blog_thumbnails.length; i++){
        //     blogThumbnailAddEvent( blog_thumbnails[i],i);
        // }
    }
    verticalSlider01(){

        const indexScroll = document.querySelector("#p-index__scroll");
        if(indexScroll) {
            // const verticalSwiper01 = new Swiper('.vertical--slider01', {
            //     speed:9000,
            //     loop:true,
            //     loopAdditionalSlides : 2.5,
            //     loopedSlides: 3,
            //     // slidesPerView: 2.5,
            //     slidesPerView: 'auto',
            //     allowTouchMove:false,
            //     simulateTouch:false,
            //     direction: 'vertical',
            //     autoplay: {
            //         delay: 0,
            //     },
            //     freeMode: true,
            // });
            const animation = { duration: 15000, easing: (t) => t }
            new KeenSlider('.vertical--slider01', {
                loop: true,
                mode:'free',
                renderMode: "performance",
                drag: false,
                vertical: true,
               
                slides: {
                    perView: 2,
                    spacing: 20,
                },
                created(s) {
                    s.moveToIdx(1, true, animation)
                },
                updated(s) {
                    s.moveToIdx(s.track.details.abs + 1, true, animation)
                },
                animationEnded(s) {
                    s.moveToIdx(s.track.details.abs + 1, true, animation)
                },
            });
        }
    }
    verticalSlider02(){
        const indexScroll = document.querySelector("#p-index__scroll");
        if(indexScroll) {
            // const verticalSwiper02 = new Swiper('.vertical--slider02', {
            //     speed:9000,
            //     loop:true,
            //     loopAdditionalSlides : 2.5,
            //     loopedSlides: 3,
            //     // slidesPerView: 2.5,
            //     slidesPerView: 'auto',
            //     allowTouchMove:false,
            //     simulateTouch:false,
            //     direction: 'vertical',
            //     autoplay: {
            //         delay: 0,
            //         // reverseDirection: true,
            //     },
            //     freeMode: true,
            // });
            const animation = { duration: 15000, easing: (t) => t }

            new KeenSlider('.vertical--slider02', {
                loop: true,
                mode:'free',
                renderMode: "performance",
                drag: false,
                vertical: true,
                rtl:true,
                
                slides: {
                    perView: 2,
                    spacing: 20,
                },
                created(s) {
                    s.moveToIdx(1.1, true, animation)
                },
                updated(s) {
                    s.moveToIdx(s.track.details.abs + 1.1, true, animation)
                },
                animationEnded(s) {
                    s.moveToIdx(s.track.details.abs + 1.1, true, animation)
                },
            });
        }
    }
    featureSlider01(){
        const indexScroll = document.querySelector("#p-index__scroll");
        if(indexScroll) {
            // const featureSwiper01 = new Swiper('.feature-swiper-container01', {
            //     speed:8000,
            //     loop:true,
            //     spaceBetween: 20,
            //     loopAdditionalSlides : 1.5,
            //     slidesPerView: 1.5,
            //     allowTouchMove:false,
            //     simulateTouch:false,
            //     autoplay: {
            //         delay: 0,
            //     },
            //     freeMode: true,
            //     breakpoints: {   
            //         576: {
            //             loopAdditionalSlides : 2.5,
            //             slidesPerView: 2.5,
            //         }
            //     }
            // });
            const animation = { duration: 10000, easing: (t) => t }

            new KeenSlider('.feature-swiper-container01', {
                loop: true,
                mode:'free',
                renderMode: "performance",
                drag: true,
                slides: {
                    origin: "center",
                    perView: 1.8,
                    spacing: 10,
                },
                // created(s) {
                //     s.moveToIdx(1.1, true, animation)
                // },
                // updated(s) {
                //     s.moveToIdx(s.track.details.abs + 1.1, true, animation)
                // },
                // animationEnded(s) {
                //     s.moveToIdx(s.track.details.abs + 1.1, true, animation)
                // },
            });
        }
    }
    featureSlider02(){
        const indexScroll = document.querySelector("#p-index__scroll");
        if(indexScroll) {
            // const featureSwiper02 = new Swiper('.feature-swiper-container02', {
            //     speed:8000,
            //     loop:true,
            //     spaceBetween: 20,
            //     loopAdditionalSlides : 1.5,
            //     slidesPerView: 1.5,
            //     allowTouchMove:false,
            //     simulateTouch:false,
            //     autoplay: {
            //         delay: 0,
            //         // reverseDirection: true,
            //     },
            //     freeMode: true,
            //     breakpoints: {   
            //         576: {
            //             loopAdditionalSlides : 2.5,
            //             slidesPerView: 2.5,
            //         }
            //     }
            // });
            const animation = { duration: 10000, easing: (t) => t }

            new KeenSlider('.feature-swiper-container02', {
                loop: true,
                mode:'free',
                renderMode: "performance",
                drag: true,
                rtl: true,
                slides: {
                    origin: "center",
                    perView: 1.8,
                    spacing: 10,
                },
                // created(s) {
                //     s.moveToIdx(1.1, true, animation)
                // },
                // updated(s) {
                //     s.moveToIdx(s.track.details.abs + 1.1, true, animation)
                // },
                // animationEnded(s) {
                //     s.moveToIdx(s.track.details.abs + 1.1, true, animation)
                // },
            });
        }
    }
    productSlider(){
        const product_thumbnails = document.querySelectorAll('.p-products__slider--thumbnails a');
        const productSlider = new Swiper('#p-products__slider', {
            navigation:  {
                nextEl: '#p-products__slider .swiper-button-next',
                prevEl: '#p-products__slider .swiper-button-prev',
            },
            on: {
                transitionStart(){
                    var	self = this;
                    for(var i = 0; i <  product_thumbnails.length; i++){
                        product_thumbnails[i].classList.remove('active');
                        product_thumbnails[self.realIndex].classList.add('active');
                    }
                }
            },
            preloadImages: false,
            lazy: {
                loadPrevNext: true,
            },
            loop : true
        });
        
        for(var i = 0; i <  product_thumbnails.length; i++){
            productThumbnailAddEvent( product_thumbnails[i],i);
        }
        function productThumbnailAddEvent(el,i){
            el.addEventListener('click',function(e){
                e.preventDefault();
                productSlider.slideTo(i+1);
            })
        }
    }
    serviceSlider(){
        const serviceSwiper = new Swiper('.c-lower__service--slider', {
            loop: true,
            //effect :'fade',
            speed:1600,
            simulateTouch :false,
            allowTouchMove:false,
            autoplay: {
                delay: 5500
            },
            pagination: {
                el: ".c-lower__service--slider .swiper-pagination",
                clickable: true,
            },
        });
    }
}